/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popNewNftDetail.vue?vue&type=template&id=4da2b57b&scoped=true"
import script from "./popNewNftDetail.vue?vue&type=script&lang=js"
export * from "./popNewNftDetail.vue?vue&type=script&lang=js"
import style0 from "./popNewNftDetail.vue?vue&type=style&index=0&id=4da2b57b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da2b57b",
  null
  
)

export default component.exports